<template>
    <div class="svg-container ">
        <svg id="ie-number-line-chart"></svg>
    </div>
</template>

<script>
    import * as d3 from "d3";
    
    export default {
        name: 'NumberLine2',
        props : { chartData:Number },
        data () {
            return {}
        },
        mounted () {
            this.dataCheck(this.chartData);
        },
        methods: {
            dataCheck (num) {
                if(Number.isInteger(num)) {
                    this.makeNumberLine();
                }
            },
            makeNumberLine () {

                const chartWidth = 500;
                const chartHeight = 100;
		
                const data = [
                    {value: this.chartData, dataset:"mindset"}
                ];
                
                // Add svg to 
                var svg = d3.select("#ie-number-line-chart")
                    .attr('width', chartWidth)
                    .attr('height', chartHeight)
                    .attr("viewBox", `0 0 ${chartWidth} ${chartHeight}`)
                    .attr("preserveAspectRatio", "xMidYMid meet")
                    .append('g')
                    .attr('transform', 'translate(' + 100 + ', 0)')
                    .attr('class', 'container')

                // set the ranges
                var y = d3.scaleBand()
                    .range([chartHeight-20, 0])
                    .padding(0.5);

                var x = d3.scaleLinear()
                    .range([0, chartWidth - 200]);

                // Scale the range of the data in the domains. Setting manually
                x.domain([-8,8]) // 
                
                // Place circle for reference point for symbol
                svg
                    .selectAll(".bars")
                    .data(data)
                    .enter()
                    
                    // circle
                    .append("circle")
                    .attr("class", "arrowRef")
                    .attr("r", 0)
                    .attr("cx", function(d) { 
                        return x(d.value); 
                    })
                    .attr("cy", chartHeight/2 - 20)
                    
                // get circle position
                var groupElement = document.querySelector('.arrowRef');
                var bboxGroup = groupElement.getBBox();
                
                const arrowX = bboxGroup.x
                const arrowY = bboxGroup.y
                // console.log(arrowX, arrowY)

                var triangle = d3.symbol().type(d3.symbolTriangle).size(25);
                svg
                    .append("path")
                    .attr('d', triangle)
                    .style("fill", "#000")
                    // .style("stroke-width", 2)
                    .attr("transform", `translate(${arrowX},${arrowY}) rotate(180)`)                
                svg
                    .append("text")
                    .text("YOUR RESULT")
                    // .attr("x", 150)
                    // .attr("y", chartHeight/2 + 5)
                    .attr("class", "chart-style")
                    .attr("text-anchor", "middle")
                    .attr("font-size", "9px")   
                    .attr("fill", "#000")
                    .attr("transform", `translate(${arrowX},${arrowY - 6})`)

                // left and right text
                svg
                    .append("g")
                    .attr("class", "labels")

                // add origin line to number line
                // svg
                //     .selectAll(".labels")
                //     .append('line')
                //     .style("stroke", "black")
                //     .style("stroke-width", 1)
                //     .attr("x1", (chartWidth-200)/2)
                //     .attr("y1", chartHeight/2 - 15)
                //     .attr("x2", (chartWidth-200)/2)
                //     .attr("y2", chartHeight/2 + 15)

                // bar for arrows
                svg
                    .selectAll(".labels")
                    .append("rect")
                    .attr("x", 0)
                    .attr("y", chartHeight/2 - 10)
                    .attr("width", 300)
                    .attr("height", 20 )
                    .attr("fill", "#1faf67")  

                svg
                    .selectAll(".labels")
                    .append("text")
                    .text("Enterprise")
                    .attr("x", -90)
                    .attr("y", chartHeight/2 + 4)
                    .attr("text-anchor", "right")
                    .attr("font-size", "11px")   
                    .attr("fill", "#000000")            
                svg
                    .selectAll(".labels")
                    .append("text")
                    .text("Unit/Team")
                    .attr("x", 325)
                    .attr("y", chartHeight/2 + 4)
                    .attr("text-anchor", "left")
                    .attr("font-size", "11px")   
                    .attr("fill", "#000000")
                    
                svg
                    .selectAll(".labels")
                    .append("text")
                    .text("MINDSET")
                    .attr("x", 150)
                    .attr("y", chartHeight/2 + 5)
                    .attr("text-anchor", "middle")
                    .attr("font-size", "15px")   
                    .attr("fill", "#FFF")
                
                
                

                const triangle2 = d3.symbol().type(d3.symbolTriangle).size(325);
                // left arrow
                svg
                    .selectAll(".labels")
                    .append("path")
                    .attr('d', triangle2)
                    .style("stroke", "#1faf67")
                    .attr("fill", "#1faf67")    
                    .attr("transform", `translate(${0},${chartHeight/2}) rotate(270)`)
                    

                // right arrow
                svg
                    .selectAll(".labels")
                    .append("path")
                    .attr('d', triangle2)
                    .style("stroke", "#1faf67")
                    .attr("fill", "#1faf67")    
                    .attr("transform", `translate(${300},${chartHeight/2}) rotate(90)`)
                    
                

                // add the x Axis -  don't add only for debug
                // svg.append("g")
                //     .attr("transform", `translate(0,${chartHeight/2})`)
                //     .attr("class", "numberline-axis-x")
                //     .call(d3.axisBottom(x));
            },
            wrap (text, width) {
                text.each(function() {
                    var text = d3.select(this),
                        words = text.text().split(/\s+/).reverse(),
                        word,
                        line = [],
                        lineNumber = 0,
                        lineHeight = 1.1, // ems
                        y = text.attr("y"),
                        dy = parseFloat(text.attr("dy")),
                        tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                    while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    }
                    }
                });
            }
        }  
    }
</script>
